import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import {
  SiJavascript,
  SiTypescript,
  SiGo,
  SiPython,
  SiRuby,
  SiCplusplus,
  SiC,
  SiMysql,
  SiMongodb,
  SiGraphql,
  SiReact,
  SiNodedotjs,
  SiExpress,
  SiGit,
  SiDocker,
  SiAmazon,
} from 'react-icons/si';
import { FaMicrochip, FaJava, FaMicrosoft } from 'react-icons/fa';
import { TechIcon } from './components';
import { IconType } from 'react-icons';

interface TechSkill {
  name: string;
  icon: IconType;
}

export const Techstack = (): React.ReactNode => {
  const [hoveredSkill, setHoveredSkill] = useState<string | null>(null);

  const techSkills: TechSkill[] = [
    { name: 'JavaScript', icon: SiJavascript },
    { name: 'TypeScript', icon: SiTypescript },
    { name: 'Go', icon: SiGo },
    { name: 'Python', icon: SiPython },
    { name: 'Ruby', icon: SiRuby },
    { name: 'Java', icon: FaJava },
    { name: 'C#', icon: FaMicrosoft },
    { name: 'C++', icon: SiCplusplus },
    { name: 'C', icon: SiC },
    { name: 'SQL', icon: SiMysql },
    { name: 'NoSQL', icon: SiMongodb },
    { name: 'GraphQL', icon: SiGraphql },
    { name: 'Microservices', icon: FaMicrochip },
    { name: 'React', icon: SiReact },
    { name: 'Node.js', icon: SiNodedotjs },
    { name: 'Express.js', icon: SiExpress },
    { name: 'MongoDB', icon: SiMongodb },
    { name: 'Git', icon: SiGit },
    { name: 'Docker', icon: SiDocker },
    { name: 'AWS', icon: SiAmazon },
  ];

  return (
    <Box sx={{ mb: 6 }}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'repeat(2, 1fr)',
            sm: 'repeat(3, 1fr)',
            md: 'repeat(4, 1fr)',
          },
          gap: 3,
          justifyContent: 'center',
        }}
      >
        {techSkills.map(skill => {
          const IconComponent = skill.icon;
          const isHovered = hoveredSkill === skill.name;
          return (
            <TechIcon
              key={skill.name}
              onMouseEnter={() => setHoveredSkill(skill.name)}
              onMouseLeave={() => setHoveredSkill(null)}
              isHovered={isHovered}
            >
              <Box className='icon-container'>
                <IconComponent className='icon' />
              </Box>
              <Typography variant='h6' className='skill-name'>
                {skill.name}
              </Typography>
            </TechIcon>
          );
        })}
      </Box>
    </Box>
  );
};
